import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Added Link import
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';

const apiUrl = process.env.REACT_APP_API_URL;

function AdminProfile() {
  const [profile, setProfile] = useState({ name: '', username: '', email: '', password: '' });
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    setLoading(true);
    setMessage('');
    setMessageType('');

    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to view your profile.');
        setMessageType('error');
        setLoading(false);
        return;
      }

      const response = await axios.get(`${apiUrl}/api/admin/profile`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });

      if (response.data.success) {
        setProfile(response.data.profile);
      } else {
        setMessage(response.data.message || 'Failed to fetch profile.');
        setMessageType('error');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error fetching profile.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setProfile((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setMessageType('');

    if (newPassword && newPassword !== confirmPassword) {
      setMessage('Passwords do not match.');
      setMessageType('error');
      setLoading(false);
      return;
    }

    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to update your profile.');
        setMessageType('error');
        setLoading(false);
        return;
      }

      const updateData = {
        name: profile.name,
        email: profile.email,
      };
      if (newPassword) {
        updateData.password = newPassword;
      }

      const response = await axios.put(`${apiUrl}/api/admin/profile`, updateData, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });

      if (response.data.success) {
        setMessage('Profile updated successfully!');
        setMessageType('success');
        setNewPassword('');
        setConfirmPassword('');
        // Update session data if name or email changed
        sessionData.name = updateData.name;
        sessionData.email = updateData.email;
        sessionStorage.setItem('adminSession', JSON.stringify(sessionData));
      } else {
        setMessage(response.data.message || 'Failed to update profile.');
        setMessageType('error');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error updating profile.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link to="/admin-dashboard" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Profile</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="card overflow-hidden">
            <div className="card-body p-24">
              <h4 className="mb-16">Admin Profile</h4>
              {message && (
                <div className={`alert alert-${messageType} mb-16`}>
                  {message}
                </div>
              )}
              <form onSubmit={handleSubmit} className="mb-24">
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value={profile.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="username" className="form-label">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    value={profile.username}
                    disabled
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={profile.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={profile.password}
                    disabled
                    placeholder="********"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="newPassword" className="form-label">New Password (leave blank to keep current)</label>
                  <input
                    type="password"
                    className="form-control"
                    id="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="form-label">Confirm New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Updating...' : 'Update Profile'}
                </button>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default AdminProfile;